import type { TMainNavItem } from '@/components/landing/layout/nav/nav'

// TODO Consider splitting this into mainNavConfig and footerNavConfig

export const mainNavConfig: TMainNavItem[] = [] as const

export type TMainNavConfig = typeof mainNavConfig
